import { render, staticRenderFns } from "./CampaignsGeneralTable.vue?vue&type=template&id=15029c66&scoped=true&"
import script from "./CampaignsGeneralTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsGeneralTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/black-dashboard/components/_campaigns-general-table.scss?vue&type=style&index=0&id=15029c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15029c66",
  null
  
)

export default component.exports